import { Link } from 'react-router-dom';

/**
 * 地区が「強い停止」中で、呼び出し元が一般ユーザー (master / 担当地区管理者でない) のときに表示する
 * 全画面「現在非公開中」プレースホルダ (地区「強い停止」Phase 1)。
 *
 * `resolveDistrictByToken` が `suspended:true` を返すと、地区データ系フィールドは返らず最小情報のみ
 * (districtName / nonPublicMessage) になる。一般ユーザーには通常フローを一切見せず、本画面で
 *   - 「現在非公開中」+ 地区名
 *   - 地区が設定した `nonPublicMessage` (未設定なら既定文言)
 *   - 関係者向けのアカウントログイン導線
 * を出す。
 *
 * スタイルは同 feature の {@link DistrictPendingScreen} に揃える (全画面中央寄せ + primary ボタン)。
 */

const DEFAULT_MESSAGE =
  'この地区は現在、一般公開を停止しています。再開までしばらくお待ちください。';

export interface NonPublicScreenProps {
  /** 地区名 (resolveDistrictByToken の最小返却に含まれる)。空のときは地区名行を出さない。 */
  districtName?: string;
  /** 地区が設定した非公開時メッセージ。未設定なら既定文言を表示。 */
  nonPublicMessage?: string;
  /** 関係者ログイン画面への遷移先 (例 `/m/:urlToken/account-login`)。未指定ならログイン導線を出さない。 */
  loginHref?: string;
}

export function NonPublicScreen({
  districtName,
  nonPublicMessage,
  loginHref,
}: NonPublicScreenProps) {
  const message = nonPublicMessage?.trim() ? nonPublicMessage.trim() : DEFAULT_MESSAGE;
  return (
    <main className="flex flex-col items-center justify-center h-dvh bg-white px-6 text-center">
      <span className="text-4xl mb-3" aria-hidden>
        🔒
      </span>
      <h1 className="text-lg font-bold text-slate-900 mb-1">現在非公開中です</h1>
      {districtName ? <p className="text-sm text-slate-600 mb-3">{districtName}</p> : null}
      <p className="text-sm text-slate-700 mb-8 max-w-sm whitespace-pre-line leading-relaxed">
        {message}
      </p>
      <div className="flex flex-col items-center gap-3">
        {loginHref ? (
          <Link
            to={loginHref}
            className="inline-block bg-primary-600 text-white text-sm font-medium py-3 px-5 rounded-md hover:bg-primary-700"
          >
            関係者の方はこちらからログイン
          </Link>
        ) : null}
        <Link
          to="/"
          className="text-sm text-slate-500 underline underline-offset-2 hover:text-slate-700"
        >
          トップに戻る
        </Link>
      </div>
    </main>
  );
}
